export const VARIANT_PARTS={date:["day","month","year"],month:["month","year"],year:["year"]};